import React, { useRef } from 'react'
import { MidBoxLeft, MidBoxMid, MidBoxRight, MidBoxRightBox, MidBoxRightBoxData, MidBoxRightBoxTitle, MidBoxWrapper, TopBoxData, TopBoxTitle } from '../styles'
import { useAllUsers } from 'CRM/hooks/Dashboard/GetAllUser';
import { useRank } from 'CRM/hooks/Dashboard/GetDashboardRank';
import AnalysisChart from 'CRM/components/AnalysisChart';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Icon } from 'CRM/organism/Main/styles';
import {useIsMobile} from "../../../components/IsMobile";
import {MobileCalVW} from "../../../components/CalVW";

export const MidBox = () => {
  const { allUsers } = useAllUsers();
  const { amountRank, countRank } = useRank();
  const IsMobile = useIsMobile();

  // const scrollRef = useRef<HTMLDivElement>(null);
  // const handleScrollLeft = () => {
  //   if (scrollRef.current) {
  //     scrollRef.current.scrollLeft -= 250; // 스크롤 이동 거리 조절 가능
  //   }
  // };
  // const handleScrollRight = () => {
  //   if (scrollRef.current) {
  //     scrollRef.current.scrollLeft += 250; // 스크롤 이동 거리 조절 가능
  //   }
  // };

  return (
    <MidBoxWrapper IsMobile={IsMobile}>
      <MidBoxLeft IsMobile={IsMobile}>
        <TopBoxTitle IsMobile={IsMobile}>총 회원수</TopBoxTitle>
        <TopBoxData IsMobile={IsMobile}>{allUsers}</TopBoxData>
      </MidBoxLeft>
      <MidBoxMid IsMobile={IsMobile}>
        {/* <Icon onClick={handleScrollLeft} style={{position: 'absolute', zIndex: 99, top: '50%', transform: 'translate(-360px, -20px)', fontSize: '22px', color: '#fff', backgroundColor: 'rgba(0,0,0,0.3)', padding: '6px', width: 'auto', height: 'auto'}}><FaChevronLeft /></Icon>
        <Icon onClick={handleScrollRight} style={{position: 'absolute', zIndex: 99, top: '50%', transform: 'translate(360px, -20px)', fontSize: '22px', color: '#fff', backgroundColor: 'rgba(0,0,0,0.3)', padding: '6px', width: 'auto', height: 'auto'}}><FaChevronRight /></Icon> */}
        <div style={{width: IsMobile ? MobileCalVW(2000) : 2000, height:  IsMobile ? MobileCalVW(300) : 300, position: 'absolute', marginLeft:  IsMobile ? MobileCalVW(1430) : 1230}}>
          <AnalysisChart />
        </div>
      </MidBoxMid>
      <MidBoxRight IsMobile={IsMobile}>
        <MidBoxRightBox IsMobile={IsMobile}>
          <MidBoxRightBoxTitle IsMobile={IsMobile}>입금순위 TOP3</MidBoxRightBoxTitle>
          {amountRank?.map((it, idx) => (
            <MidBoxRightBoxData IsMobile={IsMobile}><span>{idx + 1}. {it.name}</span> - {it.cnt} 원</MidBoxRightBoxData>
          ))}
        </MidBoxRightBox>
        <MidBoxRightBox IsMobile={IsMobile}>
          <MidBoxRightBoxTitle IsMobile={IsMobile}>유치순위 TOP3</MidBoxRightBoxTitle>
          {countRank?.map((it, idx) => (
            <MidBoxRightBoxData IsMobile={IsMobile}><span>{idx + 1}. {it.name}</span> - {it.cnt} 건</MidBoxRightBoxData>
          ))}
        </MidBoxRightBox>
      </MidBoxRight>
    </MidBoxWrapper>
  )
}

export default React.memo(MidBox)